
import { NavBar } from "./nav-bar";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white pt-14">
      <header className="fixed top-0 left-0 right-0 bg-pink-50 border-b border-pink-100 z-50">
        <div className="container mx-auto px-6 xl:px-8 max-w-[1920px]">
          <NavBar />
        </div>
      </header>
      <div className="container mx-auto px-6 xl:px-8 max-w-[1920px]">
        {children}
      </div>
    </div>
  );
}
